import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome';

const TWEET = 'The People’s Guide to Power examines how our government works, how people get involved — and how they sometimes get left out.';

export default class ShareButtons extends Component {
  openPopup(service, event) {
    let services = {
      twitter: {
        url: `https://twitter.com/intent/tweet?text=${encodeURIComponent(TWEET)}&via=WNYC`,
        height: 443
      },
      facebook: {
        url: 'https://www.facebook.com/sharer/sharer.php?u=https://project.wnyc.org/guide-to-power/',
        height: 620
      }
    };
    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screen.left;
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screen.top;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;

    var left = ((width / 2) - (600 / 2)) + dualScreenLeft;
    var top = ((height / 2) - (services[service].height / 2)) + dualScreenTop;
    let features = `titlebar=no,close=no,width=600,height=${services[service].height},top=${top},left=${left}`;
    event.preventDefault();
    let opened = window.open(services[service].url, '_blank', features);
    opened.opener = null;
  }

  render() {
    return (
      <div className="box__share">
        Share:
        <button className={this.props.facebookClass} onClick={this.openPopup.bind(null, 'facebook')}>
          <FontAwesome name='facebook'/>
          Facebook
        </button>
        <button className={this.props.twitterClass} onClick={this.openPopup.bind(null, 'twitter')}>
          <FontAwesome name='twitter'/>
          Twitter
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/ShareButtons.js